import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import { IConvo } from '../../../model/convo'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchReactions from './fetch-reactions'

export default async function likeConvo(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
  convoUtils.convoService.like(convo).then((result: any) => {
    fetchReactions(context, convo)
  })

  return
}
